<template>
    <div class="no-results">
        <h5 v-if="!message && !hasErrorContentSlot">Trenutno nema podataka za prikaz.</h5>
        <h5 v-if="message && !hasErrorContentSlot">{{ message }}</h5>
        <slot name="error-content"></slot>
        <div class="image-holder"></div>
    </div>
</template>

<script>

export default {
    name: 'errormessagetext',
    props: {
        message: String
    },
    computed: {
        hasErrorContentSlot () {
            return !!this.$slots['error-content']
        }
    }
}
</script>

<style lang="scss" scoped>
.no-results {
    h5 {
        color: $error-text-color;
    }
    .image-holder {
        background-image: url(./../../../assets/background_images/no_results_background.png);
        width: 100%;
        min-height: 180px;
        background-size: 110%;
        background-position: 50%;
    }
    .text {
      font-family: "axiforma";
      font-size: 14px;
      line-height: 18px;
      letter-spacing: .3px;
      color: $font-black-color;
      padding: 10px 10px 10px 15px;
      margin-bottom: 10px;
      a {
          font-weight: 900;
          color: $font-blue-color;
      }
    }
}

@media only screen and (min-width: 800px) {
  .no-results {
    .image-holder {
      background-size: contain;
      background-repeat: no-repeat;
    }
  }
}
</style>
